import React from "react";

import AppRoutes from "./Router/AppRoutes";

function App() {
  return (
    <>
     <AppRoutes/>
    </>
  );
}

export default App;